import {useIntl} from "react-intl";
import RadioGroup from "@ui-components/RadioGroup";
import React from "react";
import {NullFilterProps, NullFilterValue} from "./types";

export const NullFilter = ({
  id,
  value,
  onChange,
}: NullFilterProps) => {

  // hooks
  const intl = useIntl();
  const options: {value: NullFilterValue, name: string}[] = [
    {value: "all", name: intl.formatMessage({id: "all_f", defaultMessage: "Tutte"})},
    {value: "null", name: intl.formatMessage({id: "null", defaultMessage: "Solo vuote"})},
    {value: "notnull", name: intl.formatMessage({id: "not_null", defaultMessage: "Solo non vuote"})},
  ];

  return (
    <div className="flex flex-col gap-1">
      <p className="text-xs font-medium">
        {intl.formatMessage({id: "show_cells", defaultMessage: "Mostra celle"})}
      </p>
      <fieldset id={id}>
        <div
          className="flex flex-col gap-0.5"
        >
          {options.map(({name, value: radioValue}) => (
            <div
              onClick={() => onChange(radioValue)}
              key={radioValue}
              className="relative flex items-center cursor-pointer gap-2"
            >
              <input
                name={id}
                readOnly
                id={radioValue}
                type="radio"
                checked={radioValue === value}
                className="focus:ring-am-500 h-3 w-3 text-black-500 border-gray-300"
              />
              <label
                htmlFor={radioValue}
                className="block text-xs font-light whitespace-nowrap"
              >
                {name}
              </label>
            </div>
          ))}
        </div>
      </fieldset>
    </div>
  )
}